/**
 * @description
 */

import { IMicrocourseDraftCommentInfo, IMicrocourseDraftCommentExtendItem } from '@umu/umu-types';

// 是否有内容，只要有选中的图片，即使没输入任何文字也算合法，可以提交
function weikeCommentValidate(commentData: IMicrocourseDraftCommentInfo) {
    let result = false;
    const extendComment = commentData.extend_comment || [];
    const length = extendComment.length;
    for (let i = 0; i < length; i++) {
        if (+extendComment[i].is_selected === 1) {
            result = true;
        }
    }
    if (commentData.comment && !!commentData.comment.trim()) {
        result = true;
    }
    return result;
}

// 是否有内容，可以没勾选图片，但只有输入框有内容则不空
function isWeikeCommentEmpty(commentData: IMicrocourseDraftCommentInfo) {
    let result = true;
    const extendComment = commentData.extend_comment || [];
    const length = extendComment.length;

    if (commentData.comment && commentData.comment.trim()) {
        return false;
    }

    for (let i = 0; i < length; i++) {
        if (+extendComment[i].is_selected === 1) {
            result = false;
            break;
        }
        if (extendComment[i].comment.trim()) {
            result = false;
            break;
        }
    }
    return result;
}

// 笔记是否包含文字
function isCommentHasWords(commentData: IMicrocourseDraftCommentInfo) {
    let result = false;
    const extendComment = commentData.extend_comment || [];
    const length = extendComment.length;
    for (let i = 0; i < length; i++) {
        if (!!extendComment[i].comment.trim()) {
            result = true;
        }
    }
    // TODO: 确认是否还需要这个兼容逻辑
    // 评论列表返回的是 content 字段，这里需要兼容一下，老接口没办法
    // 值有可能为空字符串的情况，所以不能简单通过或操作来回退，需要与 undefined 对比
    // const value = typeof commentData.comment === 'undefined' ? commentData.content : commentData.comment;
    const value = commentData.comment || '';
    if (value.trim()) {
        result = true;
    }
    return result;
}

// 是否有写了文字但没有勾选的图片
function isPictureWithWordNotChecked(commentData: IMicrocourseDraftCommentInfo) {
    let result = false;
    const extendComment = commentData.extend_comment || [];
    const length = extendComment.length;
    for (let i = 0; i < length; i++) {
        if (+extendComment[i].comment.trim() && extendComment[i].is_selected === 0) {
            result = true;
        }
    }
    return result;
}

// 过滤掉未勾选的图文笔记
function filterCheckedExtendComment(extendComment: IMicrocourseDraftCommentExtendItem[]) {
    extendComment = extendComment || [];
    const result = [];
    const length = extendComment.length;
    for (let i = 0; i < length; i++) {
        if (extendComment[i] && extendComment[i].is_selected === 1) {
            result.push(extendComment[i]);
        }
    }
    return result;
}

export default {
    weikeCommentValidate,
    isCommentHasWords,
    isPictureWithWordNotChecked,
    filterCheckedExtendComment,
    isWeikeCommentEmpty,
};
